module.exports = __webpack_public_path__ + "fonts/DM_Serif_Display-400-latin21.d797ca5.woff2";